<app-notificationbar [@openClose]="onNotificationAction"></app-notificationbar>

<app-banner></app-banner>

<router-outlet />

<app-contact></app-contact>

<app-footer></app-footer>
